import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const PbgIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        id="Vector 98"
        d="M6 16.57L6.76 16.57L6.79 17.5C6.79 17.5 8.45 17.5 9.2 17.5C9.2 17.5 10 16.35 10 16C10 15.64 8.68 16.14 8.68 16.14L8.39 16.14L7.92 16.14L7.92 14.85C7.92 14.85 8.45 14.85 8.68 14.85C8.92 14.85 9.56 14.28 9.6 14C9.63 13.68 9.2 13.5 8.79 13.5C8.39 13.5 7.64 13.5 7.2 13.5C6.75 13.5 6.76 14.85 6.76 14.85L6 14.85L6 16.57Z"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        fill="none"
      />
      <path
        id="Vector 99"
        d="M14 13.92L13.23 13.92L13.2 13C13.2 13 11.54 13 10.79 13C10.79 13 10 14.14 10 14.5C10 14.85 11.31 14.35 11.31 14.35L11.6 14.35L12.07 14.35L12.07 15.64C12.07 15.64 11.54 15.64 11.31 15.64C11.07 15.64 10.43 16.21 10.39 16.5C10.36 16.81 10.79 17 11.2 17C11.6 17 12.35 17 12.79 17C13.24 17 13.23 15.64 13.23 15.64L14 15.64L14 13.92Z"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        fill="none"
      />
      <path
        id="Vector 100"
        d="M1 19L5 19L5 4.51C5 4.51 5 1 3.6 1C2.21 1 1 1 1 1"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
        fill="none"
      />
      <path
        id="Vector 101"
        d="M19 19L15 19L15 4.51C15 4.51 15 1 16.39 1C17.78 1 19 1 19 1"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
        fill="none"
      />
      <path
        id="Vector 102"
        d="M1 4C1 4 3 3.5 3 5C3 6.5 3 10.5 3 12C3 13.5 1 13 1 13"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
        fill="none"
      />
      <path
        id="Vector 103"
        d="M19 4C19 4 17 3.65 17 5C17 6.34 17 10.5 17 12C17 13.5 19 13 19 13"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};
